import * as React from 'react';

import { MultiSelect } from '@rematter/ui-web';

import { useUsersQuery } from './SelectUser';

type UserOption = {
  key: string;
  label: string;
  extraInfo?: React.ReactNode;
};

type MultiSelectUserProps = {
  value: string[];
  onChange: (userIds: string[]) => void;
  placeholder?: string;
  isDisabled?: boolean;
  label?: string;
};

export const MultiSelectUser: React.FC<MultiSelectUserProps> = ({
  value,
  onChange,
  placeholder = 'Select users...',
  isDisabled,
  label,
}) => {
  const { data: users = [], isLoading } = useUsersQuery();

  // Map users to MultiSelect options format
  const options: UserOption[] = React.useMemo(
    () =>
      users.map((user) => ({
        key: user.id,
        label: [user.firstName, user.lastName].filter(Boolean).join(' '),
        extraInfo: (
          <span className="text-xs text-neutral/50">{user.email}</span>
        ),
      })),
    [users],
  );

  return (
    <MultiSelect<string, UserOption>
      label={label}
      placeholder={placeholder}
      options={options}
      selectedKeys={value}
      onSelectionChange={onChange}
      isDisabled={isDisabled}
      isLoading={isLoading}
      className="@MultiSelectUser"
    />
  );
};
